export default class Enum {}
